import { useEffect, useState } from 'react';
import Modal from "@common/Modal";
import { Tab } from 'react-bootstrap';
import dateFormat from "dateformat";
import { getAgentleadHistory} from '@src/store/slices/insuranceId';


function LeadTimelineModal(props: any) {

    const {viewTimeLine, selectedLeadId} = props;
    const [loading, setLoading] = useState(false);
    const [timelineList, setTimelineList] = useState([]);


  useEffect(() => {
    if (viewTimeLine && selectedLeadId) {
        fetchHistory();
    }
}, [viewTimeLine, selectedLeadId]);

const fetchHistory = async () => {
    try {
        setLoading(true);
        const res: any = await getAgentleadHistory({ lead_id: selectedLeadId });
        setTimelineList(res?.data || []);
    } catch (err) {
        setTimelineList([]);
    } finally {
        setLoading(false);
    }
};


    return (
        

            <div className="view-timeline-popup image-timeline-popup">
                <Modal show={viewTimeLine} handleClose={() => props.handleViewTimeLine(false, 0)} >
                    <div className="modal-header">
                        <h2>Application History</h2>
                    </div>

                    <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                        <div className="modal-body" >

                            <Tab.Content>
                                <Tab.Pane eventKey="first">
                                    <table>
                                        <tbody>

                                            {
                                                !loading && timelineList.length
                                                    ?
                                                    timelineList.map((timeline: any, idx: number) =>
                                                        <tr key={idx+1}>
                                                            <td>
                                                                <span className="date">{dateFormat(timeline.created_at, 'd mmm, yyyy')}</span>
                                                                <span className="time">{dateFormat(timeline.created_at, 'hh:MM tt')}</span>
                                                            </td>
                                                            <td>
                                                                {timeline?.comment ? 
                                                                    <span className="heading" dangerouslySetInnerHTML={{ __html: timeline.comment }}></span>
                                                                :
                                                                    <><span className="heading">{timeline.status_name}</span><span className="">{timeline.sub_status_name}</span></>
                                                                }
                                                            </td>
                                                            <td>
                                                                {timeline.created_by_name || 'Admin'}
                                                                {timeline.source_name && timeline.source && timeline.source ===" LEAD_TYPE_CRM" && (
                                                                    <span className='badge badge-lead-comming'>
                                                                        ({timeline.source_name})
                                                                    </span>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    )
                                                    :
                                                    loading ? <tr><p style={{ textAlign: "center" }}>loading</p></tr> : <tr><p style={{ textAlign: "center" }}>No data found</p></tr>

                                            }

                                        </tbody>
                                    </table>

                                </Tab.Pane>

                            </Tab.Content>
                        </div>

                    </Tab.Container>
                </Modal>

            </div>

    )
}

export default LeadTimelineModal;